import { ADS_BLOCK_ID, GAME_COIN_SHORTCUT, BOOSTER_ICONS } from 'shared/constants';
import { UITypography } from 'shared/ui';
import { formatLargeNumber } from 'shared/utils';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';
import { useGameStore, useGlobalStore } from 'shared/store';
import { ShowAdsButton } from 'components';
import classNames from 'classnames';

export const Limit = () => {
  const { t } = useTranslation();

  const user = useGlobalStore((state) => state.user);
  const dailyBonusLimit = useGameStore((state) => state.settings.daily_bonus_limit);
  const maxAdsCount = useGameStore((state) => state.settings.max_count_ads);
  const botInfoLang = useGlobalStore((state) => state.botInfo.lang);
  const image = BOOSTER_ICONS.booster_energy_recharge;

  return (
    <div className={styles.limitRoot}>
      <img
        src={image}
        width={60}
        className={classNames(styles.limitIcon, {
          [styles._booster]: user.boosters.booster_daily_bonus_limit_plus?.has_active,
        })}
      />
      <div className={styles.limitContainer}>
        <div className={styles.limit}>
          <UITypography component="p" fontWeight="bold">
            {t('main_screen.your_limit')}
          </UITypography>

          <UITypography
            component="p"
            fontWeight="bold"
          >{`${formatLargeNumber(user.current_limit)}/${formatLargeNumber(user.max_daily_limit)} ${GAME_COIN_SHORTCUT}`}</UITypography>
        </div>
      </div>

      {user.current_count_ads < maxAdsCount && (
        <ShowAdsButton
          rewardType="daily_limit_increase"
          blockId={ADS_BLOCK_ID[botInfoLang]}
          textRight={`+${dailyBonusLimit}`}
          className={styles.showAdsButton}
        />
      )}
    </div>
  );
};
